import { observable, decorate, action } from 'mobx'
import { CognitoUserAttribute } from 'amazon-cognito-identity-js'
import cognitoUserPool from '../cognito-objects/cognitoUserPool'
import axios from 'axios'

const initialState = {
  user: {
    name: '',
    password: '',
    confirmPassword: '',
    email: '',
    phoneNumber: '',
    companies: [],
    isFetching: false,
    isDone: false
  }
}

class RegisterUserStore {
  constructor (rootStore) {
    this.user = {
      ...initialState.user
    }
    this.rootStore = rootStore.stores
  }

  handleChange (value, name) {
    this.user[name] = value
  }

  setIsDone (isDone) {
    this.user.isDone = isDone
  }

  setCompanies (companies) {
    this.user.companies = companies
  }

  toggleCompany (i) {
    this.user.companies[i].isChecked = !this.user.companies[i].isChecked
  }

  resetState () {
    this.user = {
      ...initialState.user
    }
  }

  verifyToken (event, token) {
    event.preventDefault()
    this.user.isFetching = true
    const url = `https://jyvm4igw11.execute-api.us-west-2.amazonaws.com/PRD/validateToken?`
    axios.post(url, {
      token: token
    })
      .then(response => {
        if (response.data.msg) {
          this.rootStore.notificationStore.sendErrorNotification('Erro', response.data.msg)
          this.user.isFetching = false
        } else {
          this.user.isFetching = false
          this.registerUser()
        }
      })
      .catch(error => {
        console.log(error)
        this.user.isFetching = false
      })
  }

  registerUser () {
    const password = this.user.password
    const confirmPassword = this.user.confirmPassword
    if (password !== confirmPassword || !password) {
      this.rootStore.notificationStore.sendErrorNotification('Erro!', 'As senhas não coincidem')
      this.user.isFetching = false
      return
    }
    const email = this.user.email
    const phoneNumber = this.user.phoneNumber.replace(/\(|\)| |\-/g, '')
    const name = this.user.name
    const phoneNumberAttribute = {
      Name: 'phone_number',
      Value: phoneNumber
    }
    const companyNameAttribute = {
      Name: 'custom:empresa',
      Value: 'none'
    }
    const nameAttribute = {
      Name: 'name',
      Value: name
    }
    const attributeList = []
    attributeList.push(new CognitoUserAttribute(phoneNumberAttribute))
    attributeList.push(new CognitoUserAttribute(companyNameAttribute))
    attributeList.push(new CognitoUserAttribute(nameAttribute))
    const registerUserObj = this
    cognitoUserPool.signUp(email, password, attributeList, null, (error, result) => {
      if (error) {
        console.log(error)
        registerUserObj.rootStore.notificationStore.sendErrorNotification('Erro!', error.message)
        registerUserObj.user.isFetching = false
      } else {
        this.createUser(result.userSub)
        registerUserObj.rootStore.confirmUserStore.setEmail(email)
        registerUserObj.rootStore.loginStore.setEmail(email)
        this.user.isDone = true
        registerUserObj.rootStore.notificationStore.sendSuccessNotification('Pronto!', `Verifique o email ${this.user.email} e confirme seu cadastro`)
      }
    })
  }

  createUser (id) {
    const url = process.env.REACT_APP_AWS_URL + '/createUser'
    axios.post(url, {
      id: id,
      name: this.user.name,
      email: this.user.email,
      profiles: ['customer'],
      companies: this.user.companies.filter(data => data.isChecked).map(company => company.id),
      phoneNumber: this.user.phoneNumber.replace(/\(|\)| |\-/g, '')
    })
    .then(results => {
      this.user.isFetching = false
    })
    .catch(error => {
      console.log(error)
      this.user.isFetching = false
    })
  }
}

decorate(RegisterUserStore, {
  user: observable,
  handleChange: action
})

export default RegisterUserStore



// WEBPACK FOOTER //
// ./src/stores/registerUserStore.js